import supabase from "@/lib/supabase";
import { UserWithRole } from "./types";

// دالة تسجيل الدخول - مع فحص شامل للحسابات غير المفعلة
export const signInWithAuth = async (email: string, password: string) => {
  console.log("Starting authentication for:", email);

  try {
    // التحقق المبكر من حالة تنشيط الحساب قبل تسجيل الدخول
    const { data: employeeData, error: preCheckError } = await supabase
      .from("employees")
      .select("active, id")
      .eq("email", email)
      .single();
    
    // اكتشاف مبكر للحسابات غير المفعلة
    if (!preCheckError && employeeData) {
      console.log("Pre-auth employee check:", employeeData);
      
      // Check for inactive account
      if (employeeData.active === false || 
          employeeData.active === 0 || 
          employeeData.active === "false" || 
          employeeData.active === "0" || 
          !employeeData.active) {
        console.log("Inactive account detected before authentication");
        return {
          user: null,
          session: null,
          error: new Error("الحساب غير مفعل. يرجى التواصل مع مسؤول النظام.")
        };
      }
    }
    
    // تسجيل الدخول باستخدام Supabase
    const result = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    // التحقق من وجود جلسة
    if (result.data.session) {
      // تحديث وقت آخر تسجيل دخول في جدول الموظفين
      const now = new Date().toISOString();
      await supabase
        .from("employees")
        .update({ last_sign_in_at: now })
        .eq("email", email);
        
      // البحث عن معلومات المستخدم في جدول employees
      try {
        const { data: employeeData, error: employeeError } = await supabase
          .from("employees")
          .select("user_type, first_name, last_name, profile_image, gender, active, last_sign_in_at, language_preference")
          .eq("email", email);

        if (employeeError) {
          
          return { 
            user: result.data.session.user,
            session: result.data.session,
            error: result.error
          };
        } 
        
        // التأكد من أن البيانات مصفوفة وتحتوي على عناصر
        if (employeeData && Array.isArray(employeeData) && employeeData.length > 0) {
          // التحقق من أن المستخدم نشط - تحقق صارم
          console.log("Employee active status:", employeeData[0].active);
          
          // Consider various ways the active flag might be stored 
          // in the database (boolean false, 0, "inactive", etc.)
          const isInactive = (
            employeeData[0].active === false || 
            employeeData[0].active === 0 || 
            employeeData[0].active === "false" || 
            employeeData[0].active === "0" || 
            (typeof employeeData[0].active === "string" && 
              (employeeData[0].active.toLowerCase() === "inactive" || 
               employeeData[0].active.toLowerCase() === "غير نشط"))
          );
          
          if (isInactive) {
            console.log("Account inactive detected in authFunctions");
            // Sign out any existing session to ensure they can't bypass the check
            try {
              await supabase.auth.signOut();
            } catch (signOutErr) {
              console.error("Error signing out inactive user:", signOutErr);
            }
            
            return {
              user: null,
              session: null,
              error: new Error("الحساب غير مفعل. يرجى التواصل مع مسؤول النظام.")
            };
          }
          
          // تعيين دور المستخدم والاسم من جدول employees
          const userWithRole: UserWithRole = {
            ...result.data.session.user,
            role: employeeData[0].user_type, // إضافة الدور من قاعدة البيانات
            first_name: employeeData[0].first_name, // إضافة الاسم الأول
            last_name: employeeData[0].last_name, // إضافة الاسم الأخير
            profile_image: employeeData[0].profile_image, // إضافة صورة الملف الشخصي
            gender: employeeData[0].gender, // إضافة الجنس
            active: employeeData[0].active, // إضافة حالة التنشيط
            last_sign_in_at: employeeData[0].last_sign_in_at, // إضافة وقت آخر تسجيل دخول
            language_preference: employeeData[0].language_preference || "ar" // إضافة اللغة المفضلة
          };
          
          
          
          
          
          return {
            user: userWithRole,
            session: result.data.session,
            error: result.error
          };
        }
      } catch (err) {
        console.error("Error fetching employee data:", err);
        return {
          user: null,
          session: null,
          error: err instanceof Error ? err : new Error("حدث خطأ غير معروف أثناء تسجيل الدخول")
        };
      }
    }

    return {
      user: result.data.session?.user || null,
      session: result.data.session,
      error: result.error
    };
  } catch (error) {
    console.error("Error during authentication:", error);
    return {
      user: null,
      session: null,
      error: error instanceof Error ? error : new Error("حدث خطأ غير معروف أثناء تسجيل الدخول")
    };
  }
};

// دالة إنشاء حساب جديد
export const signUpWithAuth = async (email: string, password: string) => {
  const result = await supabase.auth.signUp({ email, password });
  return result;
};

// دالة تسجيل الخروج
export const signOutFromAuth = async () => {
  try {
    // تسجيل الخروج من Supabase
    
    await supabase.auth.signOut();
    
    // مسح جميع توكنات Supabase من التخزين المحلي
    
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('sb-')) {
        keysToRemove.push(key);
      }
    }
    
    // إزالة المفاتيح بشكل منفصل لتجنب مشاكل التكرار أثناء الحذف
    keysToRemove.forEach(key => {
      
      localStorage.removeItem(key);
    });
    
    // التأكد من مسح توكن رئيسي معين
    const supabaseURL = "srrsrfwognluuaxudjhi";
    const specificToken = `sb-${supabaseURL}-auth-token`;
    if (localStorage.getItem(specificToken)) {
      
      localStorage.removeItem(specificToken);
    }
    
    // مسح كوكي Took
    
    document.cookie = "Took=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    
    
  } catch (error) {
    
    // المحاولة النهائية لمسح التوكنات حتى في حالة الخطأ
    try {
      // مسح جميع مفاتيح Supabase من localStorage
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('sb-')) {
          localStorage.removeItem(key);
        }
      }
      
      // مسح كوكي Took حتى في حالة الخطأ
      document.cookie = "Took=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    } catch (localStorageError) {
      console.error("Error clearing localStorage:", localStorageError);
    }
    throw error;
  }
};

// دالة إعادة تعيين كلمة المرور
export const resetPasswordWithAuth = async (email: string) => {
  const result = await supabase.auth.resetPasswordForEmail(email);
  return result;
};

// دالة فحص حالة تسجيل الدخول الحالية
export const checkCurrentAuthSession = async () => {
  const { data } = await supabase.auth.getSession();
  return data.session;
};

// دالة مساعدة للانتظار قبل إعادة المحاولة
const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// دالة جلب معلومات دور المستخدم والاسم مع آلية إعادة المحاولة
export const fetchUserRole = async (email: string | undefined | null) => {
  if (!email) {
    
    return { role: null, first_name: null, last_name: null, profile_image: null, gender: null, active: null, language_preference: null };
  }
  
  
  
  // عدد مرات المحاولة والتأخير بين المحاولات
  const maxRetries = 3;
  const initialDelayMs = 1000; // 1 ثانية

  // محاولة الاتصال بـ Supabase مع إعادة المحاولة
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      
      
      // تعديل الاستعلام لجلب الاسم الأول والأخير وصورة الملف الشخصي والجنس واللغة المفضلة
      const { data, error } = await supabase
        .from("employees")
        .select("user_type, first_name, last_name, profile_image, gender, active, language_preference")
        .eq("email", email);
      
      if (error) {
        // لو الخطأ مرتبط بشبكة الاتصال، حاول مرة أخرى
        if (error.message?.includes("Failed to fetch") || 
            error.message?.includes("NetworkError") ||
            error.message?.includes("ERR_INSUFFICIENT_RESOURCES")) {
          
          if (attempt < maxRetries) {
            const delayMs = initialDelayMs * attempt; // زيادة التأخير مع كل محاولة
            
            await wait(delayMs);
            continue; // الانتقال للمحاولة التالية
          }
        }
        
        
        return { role: null, first_name: null, last_name: null, profile_image: null, gender: null, active: null, language_preference: null };
      }
      
      
      
      if (data && Array.isArray(data) && data.length > 0) {
        
        return {
          role: data[0].user_type,
          first_name: data[0].first_name,
          last_name: data[0].last_name,
          profile_image: data[0].profile_image,
          gender: data[0].gender,
          active: data[0].active,
          language_preference: data[0].language_preference || "ar"
        };
      }
      
      
      return { role: null, first_name: null, last_name: null, profile_image: null, gender: null, active: null };
    } catch (error) {
      // التعامل مع الأخطاء غير المتوقعة
      const errorMessage = error instanceof Error ? error.message : String(error);
      if (attempt < maxRetries && (
        errorMessage.includes("Failed to fetch") ||
        errorMessage.includes("NetworkError") ||
        errorMessage.includes("ERR_INSUFFICIENT_RESOURCES")
      )) {
        const delayMs = initialDelayMs * attempt;
        
        await wait(delayMs);
        continue;
      }
      
      
      return { role: null, first_name: null, last_name: null, profile_image: null, gender: null, active: null };
    }
  }
  
  
  return { role: null, first_name: null, last_name: null, profile_image: null, gender: null, active: null, language_preference: null };
};
